// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_Jr4","cls2":"Unibrow-cls2_JVn Unibrow-cls1_Jr4"};